import { backendApi } from "./backendApi.rtkq";

// Types for questions data
export interface QuestionItem {
  q: string;
  a: string;
}

export interface GenerateQuestionsRequest {
  transcriptionId: string;
}

export interface GenerateQuestionsResponse {
  success: boolean;
  data?: {
    questions: QuestionItem[];
  };
  message?: string;
}

export interface UpdateQuestionAnswerRequest {
  transcriptionId: string;
  userId: string;
  questionIndex: number;
  answer: string;
}

export const questionsApi = backendApi.injectEndpoints({
  endpoints: (builder) => ({
    // Generate questions mutation
    // Generate questions via Nest → Firebase callable generateQuestionsForTranscription.
    // Do not send officeId: Nest forwards the Firebase ID token; CF reads
    // claims.officeId || claims.accountId.
    generateQuestions: builder.mutation<{ questions: QuestionItem[] }, GenerateQuestionsRequest>({
      query: ({ transcriptionId }) => ({
        url: `/transcriptions/${transcriptionId}/questions`,
        method: "POST",
      }),
      transformResponse: (response: any) => {
        // Backend may wrap in { success, data } or return directly
        return response.data || response;
      },
      // No invalidation needed - real-time listener handles updates automatically
    }),

    // Update question answer mutation
    updateQuestionAnswer: builder.mutation<{ success: boolean }, UpdateQuestionAnswerRequest>({
      query: ({ transcriptionId, questionIndex, answer }) => ({
        url: `/transcriptions/${transcriptionId}/questions/${questionIndex}`,
        method: "PUT",
        body: { answer },
      }),
      transformResponse: () => ({ success: true }),
      invalidatesTags: (_result, _error, { userId, transcriptionId }) => [
        { type: "Transcriptions", id: `user-${userId}` },
        { type: "Transcriptions", id: `transcription-${transcriptionId}` },
      ],
    }),
  }),
});

export const { useGenerateQuestionsMutation, useUpdateQuestionAnswerMutation } = questionsApi;
